import { render, staticRenderFns } from "./HistoricalActions.vue?vue&type=template&id=8dae178e"
import script from "./HistoricalActions.vue?vue&type=script&lang=js"
export * from "./HistoricalActions.vue?vue&type=script&lang=js"
import style0 from "./HistoricalActions.vue?vue&type=style&index=0&id=8dae178e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports